import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';

const Facebook = React.lazy(() => import('./Facebook'));

export default class FacebookWrapper extends Component {
  render() {
    return (
      <div>
        <Suspense fallback={null}>
          <Facebook config={this.props.config} reportEvent={this.props.reportEvent} />
        </Suspense>
      </div>
    );
  }
}

FacebookWrapper.propTypes = {
  config: PropTypes.object.isRequired,
  reportEvent: PropTypes.func,
};
